import {Injectable, signal, WritableSignal} from '@angular/core';
import {ColindanteItem, ListaOpcionesProyectoItem} from '../../../../interfaces/proyecto.interface';

@Injectable({
    providedIn: 'root'
})
export class UbicacionService {
    constructor() {
    }
    public colindantes: WritableSignal<ColindanteItem[]> = signal([])
    public listaUbicacionColindantes: ListaOpcionesProyectoItem[] = [
        {
            code: 1,
            name: 'Norte'
        },
        {
            code: 2,
            name: 'Sur'
        },
        {
            code: 3,
            name: 'Este'
        },
        {
            code: 4,
            name: 'Oeste'
        }
    ]
    public listaCobertura: ListaOpcionesProyectoItem[] = [
        {
            code: 1,
            name: 'Pasto'
        },
        {
            code: 2,
            name: 'Mantorral'
        },
        {
            code: 3,
            name: 'Arbusto'
        },
        {
            code: 4,
            name: 'Cultivo'
        },
        {
            code: 5,
            name: 'Bosque'
        }
    ]
    public listaRelieve: ListaOpcionesProyectoItem[] = [
        {
            code: 1,
            name: 'Ligeramente inclinado (0%-2%)'
        },
        {
            code: 2,
            name: 'Ondulado suave (3-4%)'
        },
        {
            code: 3,
            name: 'Ondulado (5-12%)'
        },
        {
            code: 4,
            name: 'Alomado (13-25%)'
        },
        {
            code: 5,
            name: 'Quebrado (26-35%)'
        },
        {
            code: 6,
            name: 'Accidentado (36-70%)'
        },
        {
            code: 7,
            name: 'Muy Accidentado (>70%)'
        }
    ]
    public listaElementos: ListaOpcionesProyectoItem[] = [
        {
            code: 1,
            name: 'Elementos naturales'
        },
        {
            code: 2,
            name: 'Lugares turísticos'
        },
        {
            code: 3,
            name: 'Sitios de valor cultural'
        }
    ]
}
